import React, { useRef, useState } from "react";
import { useAdminAccount } from "./useAdminAccount";
import "./AdminAccount.css";

function ProfileForm({ account, save }) {
const [form, setForm] = useState({
  name: account.name || "",
  username: account.username || "",
  email: account.email || "",
});

  const [busy, setBusy] = useState(false);
  const [notice, setNotice] = useState(null);
  const submitting = useRef(false);

  function update(key, value) {
    setForm((previous) => ({ ...previous, [key]: value }));
  }

  async function submit(event) {
    event.preventDefault();
    if (submitting.current) return;

    submitting.current = true;
    setBusy(true);
    setNotice(null);

    try {
      const data = await save("profile", form);

  setForm({
  name: data.admin.name || "",
  username: data.admin.username || "",
  email: data.admin.email || "",
});
      setNotice({ type: "success", text: data.message });
    } catch (error) {
      setNotice({ type: "error", text: error.message });
    } finally {
      submitting.current = false;
      setBusy(false);
    }
  }

  return (
    <form onSubmit={submit}>
      {notice && (
        <div
          className={`aa-notice aa-${notice.type}`}
          role={notice.type === "error" ? "alert" : "status"}
        >
          {notice.text}
        </div>
      )}

      <fieldset disabled={busy}>
        <div className="aa-grid">
          <label>
            Full Name
            <input
              required
              maxLength={100}
              autoComplete="name"
              value={form.name}
              onChange={(event) => update("name", event.target.value)}
            />
          </label>

          <label>
            Username
            <input
              required
              minLength={3}
              maxLength={100}
              pattern="[A-Za-z0-9_.\-]+"
              autoComplete="username"
              value={form.username}
              onChange={(event) => update("username", event.target.value)}
            />
          </label>

          <label className="aa-full">
            Email Address
            <input
              type="email"
              required
              maxLength={254}
              autoComplete="email"
              value={form.email}
              onChange={(event) => update("email", event.target.value)}
            />
          </label>

         
        </div>

        <button type="submit" className="aa-submit">
          <i className="bi bi-check2-circle" aria-hidden="true" />
          {busy ? "Saving…" : "Save Profile"}
        </button>
      </fieldset>
    </form>
  );
}

export default function AdminProfile() {
  const { account, loading, loadError, save } = useAdminAccount();

  return (
    <main className="aa-page">
      <section className="aa-card">
        <header className="aa-heading">
          <span className="aa-heading-icon">
            <i className="bi bi-person-circle" aria-hidden="true" />
          </span>

          <div>
            <h1>My Profile</h1>
            <p>Update your admin account details.</p>
          </div>
        </header>

        {loading ? (
          <p role="status">Loading profile…</p>
        ) : loadError ? (
          <div className="aa-notice aa-error" role="alert">
            {loadError}
          </div>
        ) : (
          account && <ProfileForm account={account} save={save} />
        )}
      </section>
    </main>
  );
}